import * as React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux';
import FooterLoader from "../layout/footerLoader.tsx";
import HeaderLoader from "../layout/headerLoader.tsx";
import { storePage } from "../state/storePage";
import RenderPrepareContent from "./renderPrepareContent";

const container = document.getElementById("renderApp");
if (container) {
	createRoot(container).render(
		<React.StrictMode>
			<Provider store={storePage}>
				<HeaderLoader/>
				<div className="cms-sections">
					<RenderPrepareContent url={container.dataset.url}/>
				</div>
				<FooterLoader/>
			</Provider>
		</React.StrictMode>
	);
}
